import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const TournamentCategoriesFilter = ({
    tournamentCategories = [],
    loading,
    filters,
    restoreFilterValues,
    onChangeValue = () => {},
    hidden = false,
}) => (
    <Field
        component={Form.ReduxSelect}
        name='tournamentCategories'
        hidden={hidden}
        options={tournamentCategories}
        disabled={loading}
        placeholder='Category'
        loading={loading}
        multiple
        setValue={restoreFilterValues(filters, 'tournamentCategories')}
        selection
        search
        onChangeValue={onChangeValue}
    />
);

TournamentCategoriesFilter.propTypes = {
    tournamentCategories: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    onChangeValue: PropTypes.func,
    hidden: PropTypes.bool,
};
